import data from "../../../../../src/SplitPageLayout/SplitPageLayout.docs.json";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  DeprecationBanner,
  React
};